// extracted by mini-css-extract-plugin
export default {"header":"menu_header__gTghG","mainPage":"menu_mainPage__upivi"};